import changelogConfig from "./changelog.config.json";

function byId(elementId) {
  return document.getElementById(elementId);
}

function createChangeList(changes) {
  const listElement = document.createElement("ul");
  listElement.className = "changelog-entry-changes";
  for (const change of changes) {
    const itemElement = document.createElement("li");
    itemElement.textContent = String(change);
    listElement.appendChild(itemElement);
  }
  return listElement;
}

function renderChangelogEntries(containerElement, versions) {
  containerElement.innerHTML = "";
  for (const versionEntry of versions) {
    const entryElement = document.createElement("li");
    entryElement.className = "changelog-entry";

    const headerElement = document.createElement("div");
    headerElement.className = "changelog-entry-header";

    const titleElement = document.createElement("h3");
    titleElement.className = "changelog-entry-title";
    titleElement.textContent = versionEntry.version ?? "Unbekannte Version";

    const dateElement = document.createElement("p");
    dateElement.className = "changelog-entry-date";
    dateElement.textContent = versionEntry.date ?? "";

    headerElement.appendChild(titleElement);
    headerElement.appendChild(dateElement);
    entryElement.appendChild(headerElement);

    const changeList = createChangeList(
      Array.isArray(versionEntry.changes) ? versionEntry.changes : []
    );
    entryElement.appendChild(changeList);

    containerElement.appendChild(entryElement);
  }
}

async function initializePage() {
  const panelElement = byId("changelogPanel");
  const listContainer = byId("changelogList");

  // Ensure panel is visible when present
  if (panelElement) {
    panelElement.classList.remove("hidden");
  }

  const config =
    changelogConfig && Array.isArray(changelogConfig.versions)
      ? changelogConfig
      : { versions: [] };
  // Update download button label with latest version if available
  const downloadButton = document.querySelector(".download-button");
  if (
    downloadButton &&
    config.versions &&
    Array.isArray(config.versions) &&
    config.versions.length > 0 &&
    typeof config.versions[0].version === "string" &&
    config.versions[0].version.trim().length > 0
  ) {
    const latestVersion = config.versions[0].version.trim();
    downloadButton.textContent = `Download v${latestVersion}`;
    downloadButton.setAttribute("href", `./downloads/v${latestVersion}.zip`);
  }
  if (listContainer) {
    renderChangelogEntries(listContainer, config.versions);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializePage);
} else {
  initializePage();
}
